import { HttpStatusCode } from 'data/protocols/http';
import {
  ConflictError,
  InvalidCredentialsError,
  NotFoundError,
  UnexpectedError,
} from 'domain/errors';
import { VerifyInternshipResponsibleEmailUseCaseInterface } from 'domain/usecases';

export class RemoteVerifyInternshipResponsibleEmail
  implements VerifyInternshipResponsibleEmailUseCaseInterface
{
  constructor(
    private readonly url: string,
    private readonly httpClient,
  ) {}

  async execute(
    params: VerifyInternshipResponsibleEmailUseCaseInterface.Params,
  ): Promise<VerifyInternshipResponsibleEmailUseCaseInterface.Result> {
    const httpResponse = await this.httpClient.request({
      url: this.url,
      body: params,
      method: 'post',
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.unauthorized:
        throw new InvalidCredentialsError();
      case HttpStatusCode.notFound:
        throw new NotFoundError(httpResponse.body.message);
      case HttpStatusCode.conflict:
        throw new ConflictError(httpResponse.body.message);
      default:
        throw new UnexpectedError(httpResponse.body.message);
    }
  }
}
